import { Button } from "components/atoms/Button";

interface DocumentUploadModalFooterProps {
    onSave: () => void;
    onCancel: () => void;
    isLoading: boolean;
    disabled: boolean;
}

function DocumentUploadModalFooter({ onSave, onCancel, isLoading, disabled }: DocumentUploadModalFooterProps) {
    return (
        <div className="bulk-edit-tags__footer" style={{ marginTop: "30px" }}>
            <Button type="primary" onClick={onSave} disabled={disabled}>
                {!isLoading ? "Upload Csv" : "Loading..."}
            </Button>
            <Button type="link" onClick={onCancel} style={{ color: "var(--audette-black)" }}>
                Close
            </Button>
        </div>
    );
}

export default DocumentUploadModalFooter;
